import { setCookie } from '../cookie';
import { COOKIE_NAME, EVENT_NAME } from './constants';

const showPhi = () => {
  setCookie(COOKIE_NAME, '', new Date(0));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

export default showPhi;